import { IHttpService, IPromise } from "angular";
import { EnvironmentService } from "@gtmhub/env";
import { IUpgradePlan, IUpgradedEdition } from "@webapp/configuration/models/configuration.model";

interface IPortalSession {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  portal_session: string;
}

export class SubscriptionService {
  public static $inject = ["EnvironmentService", "$http"];

  constructor(private env: EnvironmentService, private $http: IHttpService) {}

  public getPortalSession(redirectUrl: string): IPromise<IPortalSession> {
    let url = this.env.getApiEndpoint("/subscriptions/portal_session");
    if (redirectUrl !== "") {
      url = url.concat("?redirect_url=", encodeURIComponent(redirectUrl));
    }
    return this.$http.get<IPortalSession>(url).then((response) => response.data);
  }

  public upgradeEditionPlan(editionUpgrade: IUpgradePlan): IPromise<IUpgradedEdition> {
    const url = this.env.getApiEndpoint("/subscriptions/upgrade");

    return this.$http.post<IUpgradedEdition>(url, editionUpgrade).then((response) => response.data);
  }
}
